import React from "react";
import { SectionHeading } from "@/components/Bits";
import { QrCode } from "lucide-react";

export default function Quality() {
  const items = [
    ["Ingredient sourcing", "Ingredients selected from trusted suppliers with an emphasis on traceability."],
    ["Manufacturing standards", "Products manufactured under quality-controlled conditions. [MANUFACTURER NAME]"],
    ["Quality testing", "Every batch subject to quality checks in line with applicable nutraceutical guidelines. [LAB TEST REPORT]"],
    ["Batch information", "Each pack carries batch, manufacturing date and expiry information."],
    ["Product traceability", "Scan the QR code on-pack to trace batch details."],
    ["Packaging standards", "Premium packaging designed to protect product integrity through delivery."],
  ];
  return (
    <div className="max-w-6xl mx-auto px-5 md:px-8 pt-14 pb-24">
      <SectionHeading eyebrow="Quality" title="Quality you can trust." />
      <div className="mt-12 grid md:grid-cols-2 gap-6">
        {items.map(([t, b]) => <div key={t} className="card-surface p-8"><div className="font-display text-2xl">{t}</div><p className="mt-2 text-asure-text2 text-sm">{b}</p></div>)}
      </div>
      <div className="mt-12 card-surface p-10 flex flex-col md:flex-row items-center gap-8">
        <div className="w-28 h-28 rounded-2xl bg-asure-ivory flex items-center justify-center"><QrCode size={64} className="text-asure-forest" /></div>
        <div>
          <div className="eyebrow">Scan & Verify</div>
          <h3 className="font-display text-3xl mt-2">Verify your ASURE product</h3>
          <p className="mt-2 text-asure-text2 text-sm max-w-lg">Every box carries a QR code. Scan it to view batch number, manufacturing date, expiry and testing information. [FSSAI LICENSE NUMBER]</p>
        </div>
      </div>
    </div>
  );
}
